<template>
  <div
    class="select-box-group"
    v-bind:style="{
      display: 'block',
    }"
  >
    <div class="select-from">
      <DxTextBox
        id="custom-templates"
        :on-value-changed="onSelectionChanged"
        :showClearButton="true"
        @initialized="initialized"
        ref="select-from-value"
        :validationMessageMode="validationMessageMode"
        :value="fromValue"
        :readOnly="setReadOnly"
        @enter-key="onPressEnter"
        :valueChangeEvent="'input'"
      >
        <DxTextBoxButton
          :options="searchTypes"
          name="search"
          location="before"
        />

        <DxTextBoxButton name="clear" location="after" />
        <template #select-from-clear>
          <div>
            <span class="dx-clear-button-area" @click="clearSelectFrom"
              ><span class="dx-icon dx-icon-clear"></span
            ></span>
          </div>
        </template>

        <template #show-drop-down>
          <div>
            <DxDropDownButton
              class="search-option"
              :showArrowIcon="false"
              :stylingMode="'text'"
              :items="filterRangeOptions()"
              keyExpr="value"
              displayExpr="text"
              :drop-down-options="{ width: 200 }"
              :onItemClick="searchOptionItemClick.bind(this)"
              :useSelectMode="true"
              :value="selectToValue"
              :selectedItemKey="selectedOperator"
              width="25"
            >
            </DxDropDownButton>
          </div>
        </template>
      </DxTextBox>
    </div>
  </div>
</template>
<script>
import {
  DxTextBox,
  DxButton as DxTextBoxButton,
} from "devextreme-vue/text-box";

export default {
  components: {
    DxTextBox,
    DxTextBoxButton,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    textBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    gridData: {
      type: Object,
      default: () => {},
    },
    // value: {
    //   type: [String, Number],
    //   default: undefined,
    // },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    setReadOnly: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    onPressEnterKey: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      searchTypes: {
        template: "show-drop-down",
        elementAttr: { class: "search-option-drop-down" },
        visible: true,
      },
      searchOptionItems: [
        { icon: "equal", text: "Equals", value: "=" },
        { icon: "startswith", text: "Begins With", value: "startswith" },
        { icon: "contains", text: "Contains", value: "contains" },
        { icon: "endswith", text: "Ends With", value: "endswith" },
      ],

      selectToValue: undefined,
      selectedOperator: undefined,

      dataField: this.textBoxOptions[0].dataField,
      defaultValue: undefined,
      validationMessageMode: this.textBoxOptions[0].validationMessageMode
        ? this.textBoxOptions[0].validationMessageMode
        : "auto",
      readOnly: this.textBoxOptions[0].readOnly || this.setReadOnly,
      fieldTemplate: this.textBoxOptions[0].fieldTemplate
        ? "field-template"
        : null,
      toValue: undefined,
      fromValue: undefined,
    };
  },
  mounted() {
    if (this.textBoxOptions[0].defaultValue) {
      if (Array.isArray(this.textBoxOptions[0].defaultValue)) {
        this.defaultValue = this.textBoxOptions[0].defaultValue[0];
      } else {
        this.defaultValue = this.textBoxOptions[0].defaultValue;
      }
    }

    this.selectedOperator = "contains";
    if (this.textBoxOptions[0].filterOperator) {
      this.selectedOperator = this.dataModel.filterOperator =
        this.textBoxOptions[0].filterOperator;
    }

    if (this.dataModel.filterOperator) {
      this.selectedOperator = this.dataModel.filterOperator;
    }

    if (this.defaultValue && this.defaultValue.length != 0) {
      if (this.dataModel.fromValue) {
        this.defaultValue = [this.dataModel.fromValue];
      } else {
        this.onSelectionChanged({ value: this.defaultValue });
      }
    } else {
      if (this.dataModel.fromValue)
        this.defaultValue = this.dataModel.fromValue;
    }
  },
  methods: {
    onPressEnter(e) {
      // var textBox = this.$refs["select-from-value"].instance;
      // if (textBox) textBox.blur();

      this.$nextTick(() => {
        this.onPressEnterKey(e);
      });
    },
    clearSelectFrom() {
      this.fromValue = undefined;

      var textBox = this.$refs["select-from-value"].instance;
      textBox.reset();
    },
    searchOptionItemClick(e) {
      if (this.$refs["select-to-value"]) {
        this.toValue = undefined;
        var textBox = this.$refs["select-to-value"].instance;
        textBox.reset();
      }

      this.selectedOperator = e.itemData.value;
      this.dataModel["filterOperator"] = e.itemData.value;

      if (this.fromValue) {
        this.onSelectionChanged({ value: this.fromValue });
      }
    },
    filterRangeOptions() {
      return this.searchOptionItems;
    },
    onSelectionChanged(e) {
      this.fromValue = e.value;
      this.dataModel["fromValue"] = e.value;
      this.setFilterArray(e);
    },

    setFilterArray(e) {
      let filter = [];
      var setFilter = [];

      if (e.value) {
        setFilter[0] = this.textBoxOptions[0].dataField;
        setFilter[1] = this.selectedOperator
          ? this.selectedOperator
          : "contains";
        setFilter[2] = e.value;

        filter.push(setFilter);
      }

      if (this.textBoxOptions[0].formLocation == "form-report") {
        this.valueChangeCallBack(this.dataField, e.value);
      } else if (this.textBoxOptions[0].formLocation == "data-grid") return;
      else this.valueChangeCallBack(this.dataField, filter);
    },
    initialized(e) {
      if (this.defaultValue) {
        e.component.beginUpdate();
        e.component.option("value", this.defaultValue);
        e.component.endUpdate();
        if (this.defaultValue)
          this.onSelectionChanged({ value: this.defaultValue });
      }
    },
    onItemClick(e) {
      if (this.textBoxOptions[0].formLocation == "data-grid")
        this.valueChangeCallBack(e, this.gridData);
    },
  },
  computed: {
    selectFromClearBtn() {
      return {
        icon: "clear",
        type: "clear",
        template: "select-from-clear",
        elementAttr: { class: "select-from-clear dx-clear-button-area" },
        visible: true,
      };
    },
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.select-box-group {
  width: 100%;
  .select-to {
    display: inline-flex;
    //   padding-top: 35px;
    span {
      vertical-align: middle;
      align-self: center;
      padding-right: 10px;
      padding-left: 5px;
    }
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;

    .dx-icon-clear {
      color: rgba(117, 117, 117, 0.87);
      background-color: rgba(194, 194, 194, 0.87);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      margin-top: -11px !important;
      width: 22px;
      height: 22px;
      background-position: 0 0;
      background-size: 12px 12px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      line-height: 12px;
    }
    .dx-icon-clear::before {
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      top: 50%;
      margin-top: -6px;
      left: 50%;
      margin-left: -6px;
    }

    .dx-inkripple .dx-inkripple-wave {
      width: 22px !important;
      height: 22px !important;
      opacity: 1 !important;
      top: 3px !important;
      left: 2px !important;
    }
  }

  .select-from-clear:hover,
  .select-from-clear:focus {
    background-color: unset;
  }
  .select-from-clear.dx-state-active {
    background-color: unset;
  }

  .select-from .dx-texteditor-input-container input.dx-texteditor-input {
    padding-right: 0 !important;
  }

  .select-to .dx-texteditor-input-container input.dx-texteditor-input {
    text-overflow: unset;
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;
  }

  .search-option {
    .dx-button-content {
      padding: 0 !important;
      .dx-icon {
        margin: 0 !important;
      }
    }
    padding: 0 !important;
  }

  .dx-dropdownbutton {
    height: auto;
  }
}
</style>
